import type { FaireProductEntity } from "../../entity_types/product";

export const p_am6jq88x2w: FaireProductEntity = {
  token: "p_am6jq88x2w",
  type: "product",
  name: "seaside watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/6daa137bd585a42acf4c736105fe9bbd6802fdda13ffc057ba29b0484757ac19.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4d38de6aef419673a4f62aa2545bcfeafb98ab598589922a309ca62674709297.jpeg",
    "https://cdn.faire.com/fastly/22a7dd6b80d24d22c17bf249844bb063a0ca980e7b3309223439ba18155581ae.jpeg",
    "https://cdn.faire.com/fastly/97d9d683ffe607897633459ba53c9af1294d6e4dbc4129b4f20c98af6afe0e1e.jpeg",
    "https://cdn.faire.com/fastly/684cc5f9606d13cbb90d598abff72791b2cfe1dbb8a0568b8d58e21416fddd99.jpeg",
    "https://cdn.faire.com/fastly/9def37dac4430f32754eb64e54e0949eb0238650992729dc3576d9015d305524.jpeg",
    "https://cdn.faire.com/fastly/00826ce34b1145cb1b6e42548ca5e2061c0cf3ce9596a2e0e7acb2b1617047a0.jpeg",
    "https://cdn.faire.com/fastly/e1fb8c6e945e5da94b248334fcf57cadbffbb75e8254a04569e7bc407aab6b8b.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve seaside illustrations — a sailboat, lighthouse, starfish, seashells, beach chair, anchor, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA strong summer and coastal-shop seller. Performs well in beach-town boutiques and as a vacation memento.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:10.812Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
